import { FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import { useSearchParams } from "react-router-dom";
import {
  ProductCartDrawer,
  fetchList,
  storeActions,
} from "../../modules/store";
import { StoreFilters } from "../../modules/store/StoreFilters";
import { ProductsStoreList } from "../../modules/store/ProductsStoreList";
import styles from "./Store.module.css";
import { useAppNotifications } from "../../components/LMNotifications";

interface Props {
  siteId: number;
  systemId: number;
}

export const Store: FC<Props> = ({ siteId, systemId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation("store");
  const { contextHolder, success, error } = useAppNotifications();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const { status, list, searchString, cartProducts } = useSelector(
    (state: RootState) => {
      return state.store;
    }
  );

  const getProducts = useCallback(() => {
    dispatch(fetchList({ siteId, searchString }));
  }, [dispatch, siteId, searchString]);

  useEffect(() => {
    dispatch(
      storeActions.setFilters({
        searchString: searchParams.get("searchString") || "",
      })
    );
  }, [searchParams, dispatch]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const showCartProducts = () => setIsCartOpen(true);
  const hideCartProducts = () => setIsCartOpen(false);

  const handlePlaceOrderSuccess = () => success(t("placeOrderSuccess"));
  const handlePlaceOrderError = () => error(t("placeOrderError"));

  return (
    <div className={styles.container}>
      {contextHolder}
      <div className={styles.filters}>
        <StoreFilters
          searchString={searchString}
          cartProducts={cartProducts}
          onShowCart={showCartProducts}
        />
      </div>
      <div className={styles.list}>
        <ProductsStoreList
          list={list}
          status={status}
          storeProducts={cartProducts}
        />
      </div>
      <ProductCartDrawer
        open={isCartOpen}
        onClose={hideCartProducts}
        siteId={siteId}
        systemId={systemId}
        onSuccess={handlePlaceOrderSuccess}
        onError={handlePlaceOrderError}
      />
    </div>
  );
};
